import { Component, OnInit, inject } from '@angular/core';
import { GlCodeService } from '../../data-access/gl-code.service';
import { CreateGLCode, GLCode } from '../../interfaces/glCode.interface';
import { MatTableModule } from '@angular/material/table'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  standalone: true,
  imports: [
    MatTableModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    NgIf,
    MatButton
  ],
  providers: [
    GlCodeService,
    FormBuilder
  ],
  selector: 'equine-ui-nx-gl-code-admin',
  templateUrl: './gl-code-admin.component.html',
  styleUrls: ['./gl-code-admin.component.scss']
})
export class GlCodeAdminComponent implements OnInit {
  
  glCodeService = inject(GlCodeService);
  formBuilder = inject(FormBuilder);

  displayedColumns = ['actions', 'id', 'glCode', 'label'];
  dataSource: GLCode[] = [];
  glCodeForm: FormGroup | undefined;

  currentId = '';

  mode: 'CREATE' | 'EDIT' = 'CREATE';

  ngOnInit() {
    this.getAllGLCodes();
    this.buildForm();
  }

  buildForm() {
    this.glCodeForm = this.formBuilder.group({
      id: [''],
      glCode: ['', Validators.required],
      label: ['', Validators.required]
    });
  }

  switchToCreateMode() {
    this.mode = 'CREATE';
    this.glCodeForm?.reset();
    this.glCodeForm?.markAsPristine();
    this.glCodeForm?.markAsUntouched();
    this.glCodeForm?.updateValueAndValidity();

    this.glCodeForm?.get('glCode')?.setErrors(null);
    this.glCodeForm?.get('label')?.setErrors(null);
  }

  getAllGLCodes() {
    this.glCodeService.getAll()
      .subscribe({
        next: (response) => {
          this.dataSource = response;
        }
      })
  }

  createOrUpdateGlCode() {
    if (this.glCodeForm) {
      if (this.mode === 'CREATE') {
        this.glCodeService.create(this.glCodeForm.value)
          .subscribe({
            next: (response) => {
              this.switchToCreateMode();
              this.getAllGLCodes();
            }
          })
      }
      if (this.mode === 'EDIT') {
        this.glCodeService.update(this.glCodeForm.get('id')?.value, this.glCodeForm.value)
          .subscribe({
            next: (response) => {
              this.switchToCreateMode();
              this.getAllGLCodes();
            }
          })
      }
    }
  }

  editRow(row: GLCode) {
    this.mode = 'EDIT';
    this.glCodeForm?.patchValue(row);
    this.glCodeForm?.markAsUntouched();
    this.glCodeForm?.markAsPristine();
  }

}
